export default __webpack_public_path__ + "static/media/angle-right.3c68ad7e.svg";